import React, { useEffect, useState } from 'react';
import { Row, Col } from "react-bootstrap";
import { format } from 'date-fns';
import { Alert, CircularProgress } from '@mui/material';
import PropTypes from 'prop-types';
import { RadioInput, SelectInput } from '../../../Helpers/Inputs';
import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../../../sessionStorage';
import TimeZones from '../../Common/Appointment/Timezones';
import BusinessDaysCalendar from "../../Common/Appointment/BusinessDaysCalendar";
import ScheduleTime from '../../Common/ScheduleTimeCard';
import { ComplimentaryReview } from '../../Common/Appointment/CustomAppointmentData';
import '../../Common/ScheduleTime.scss';

export default function TermScheduler(props) {

  const weekLabels = ['M', 'T', 'W', 'T', 'F'];
  const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL;
  const sessionStorage = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);
  const oneClickAccountId = sessionStorage && sessionStorage.account && sessionStorage.account.oneClickAccountId;
  const month = format(new Date(), 'MMMM yyyy');

  const [appointmentTimes, setAppointmentTimes] = useState([]);
  const [loader, setLoader] = useState(false);
  const [availableWeeks, setAvailableWeeks] = useState([]);
  const [selectedAppointmentDate, setSelectedAppointmentDate] = useState(null);

  const handleValueChange = (field, value) => {
    if (field === 'timeZone') {
      if (selectedAppointmentDate && value) {
        setLoader(true);
        props.setValue('specificApptTime', "");
        getAvailableAppointments(value, selectedAppointmentDate);
      }
    }
    props.onFieldChange(field, value);
  };
  useEffect(() => {
    availableDates();
  }, []);

  const getAppointmentLabel = (date, available) => {
    let label = format(new Date(date), 'p');
    if (!available) {
      label += ' (unavailable)';
    }
    return label;
  };

  const getAvailableAppointments = (timeZone, selectedDate) => {
    if (!selectedDate || !timeZone) {
      return;
    }

    setLoader(true);
    fetch(`${covrServicesUrl}/api/Case/AvailableAppointments?date=${selectedDate}&timeZone=${timeZone}&oneClickAccountID=${oneClickAccountId}`)
      .then((response) => response.text().then(text => text ? JSON.parse(text) : []))
      .then((appointments) => {
        setLoader(false);
        if (appointments.length) {
          appointments = appointments.filter((x) => x.available);
          const appts = appointments.map((a, index) => {
            return {
              value: a.appointment,
              label: getAppointmentLabel(a.appointment, a.available),
              disabled: a.available === false,
              isRadioSelect: false
            };
          });
          setAppointmentTimes(appts);
        } else {
          setAppointmentTimes([]);
        }
      });
  };

  const availableDates = () => {
    const businessDates = BusinessDaysCalendar(10);
    const availableDatesMatrix = [];
    for (let i = 0; i < businessDates.length; i += 5) {
      availableDatesMatrix.push(businessDates.slice(i, i + 5));
    }

    setAvailableWeeks(availableDatesMatrix);
  };

  useEffect(() => {
    if (props.formState.timeZone) {
      getAvailableAppointments(props.formState.timeZone, selectedAppointmentDate);
    }
  }, [selectedAppointmentDate, props.formState.timeZone]);

  const onClickDate = (businessDate) => {
    if (!businessDate.isValid) {
      return;
    }

    const selectedDate = businessDate.value;
    props.setValue('specificApptDate', selectedDate);
    props.onFieldChange('specificApptDate', selectedDate);
    setSelectedAppointmentDate(selectedDate);
  };

  const onClickSlot = (value) => {
    props.setValue('specificApptTime', value);
    props.onFieldChange('specificApptTime', value);
    const newApt = appointmentTimes;
    newApt.map((item) => {
      item.isRadioSelect = false;
    });
    setAppointmentTimes(newApt);
    const SelectedSlot = appointmentTimes.find(x => x.label === value);
    if (SelectedSlot && !SelectedSlot.isRadioSelect) {
      appointmentTimes.map((v, i) => {
        if (v.label === value && !v.isRadioSelect) {
          v.isRadioSelect = true;
        } else {
          v.isRadioSelect = false;
        }
      });
      setAppointmentTimes(newApt);
    }
  };

  return (
    <React.Fragment>
      <h6 className="mt-2"><b>What time works for you?</b></h6>
      <div className="px-2">
        <div className='specific-appt'>
          <RadioInput
            name="specificAppt"
            id="specificAppt"
            label=""
            value={props.formState.specificAppt}
            radios={[{ value: "asap", label: "Contact me within one business day" }, {
              value: "schedule",
              label: 'Schedule a Call'
            }]}
            onChange={e => handleValueChange('specificAppt', e.target.value)}
          />
        </div>
      </div>
      {props.formState.specificAppt === 'schedule' &&
        <React.Fragment>
          <Row>
            <Row className='mt-2 w-100 mb-2'><b>{month}</b></Row>
            <Row className='mt-1 w-100 mb-2 d-flex'>
              {
                weekLabels.map((item, i) => {
                  return (
                    <div className='flex-fill px-0' key={i}>
                      <div className='week-day text-center'>{item}</div>
                    </div>
                  );
                })
              }
            </Row>
            {
              availableWeeks.map((weekArray, i) => {
                return (
                  <Row className="mt-1 w-100 mb-2 d-flex ms-1" key={i}>
                    {
                      weekArray.map((calendarDate, k) => {
                        return (
                          <div className="flex-fill px-0" key={k}>
                            <div
                              className={`week-day text-center numberCircle ${calendarDate.isValid ? 'date-valid' : 'date-invalid'} ${selectedAppointmentDate === calendarDate.value ? "bgColor" : ''}`}
                              onClick={() => onClickDate(calendarDate)}>
                              {calendarDate.label}
                            </div>
                          </div>
                        );
                      })
                    }
                  </Row>
                );
              })
            }
          </Row>

          {
            props.errors && props.errors.specificApptDate && !selectedAppointmentDate &&
            (
              <Row>
                <Col md="12">
                  <Alert severity="error">{props.errors.specificApptDate.message}</Alert>
                </Col>
              </Row>
            )
          }

          {selectedAppointmentDate && (
            <div className='mt-2 apt-slot'>
              <h6>{ComplimentaryReview.appointmentTimeTitle}</h6>
              <div className='mb-3'>
                <SelectInput
                  name="timeZone"
                  id="timeZone"
                  value={props.formState.timeZone}
                  onChange={(e) => handleValueChange('timeZone', e.target.value)}
                  label="Time Zone"
                  selectOptions={TimeZones}
                />
              </div>
              {loader ? <div className='d-flex justify-content-center'><CircularProgress /></div>
                :
                appointmentTimes.length === 0 && selectedAppointmentDate && props.formState.timeZone ?
                  <Alert severity="error">There are no appointment times available on this date. Please select another
                    date.</Alert>
                  :
                  <ScheduleTime onClickSlot={onClickSlot} appointmentTimes={appointmentTimes} />
              }
              {
                props.errors && props.errors.specificApptTime &&
                <Alert severity="error" className="mt-3">{props.errors.specificApptTime.message}</Alert>
              }
            </div>
          )}
        </React.Fragment>

      }
    </React.Fragment>
  );
}

TermScheduler.propTypes = {
  errors: PropTypes.object,
  formState: PropTypes.object,
  onFieldChange: PropTypes.func,
};
